import { takeLatest, spawn, put } from 'redux-saga/effects';

/* Project */
import apiRequest from 'utils/api';
import { MODULES_ACTIONS } from './Modules.reducer';

function* getStateFromApi() {
  yield takeLatest(MODULES_ACTIONS.GET_STATE_FROM_API, function* () {
    try {
      const response = yield apiRequest('api/v1/modules');

      if (!response.data) {
        throw new Error('No data found');
      }

      yield put({ type: MODULES_ACTIONS.GET_STATE_FROM_API_SUCCESS, payload: response.data });
    } catch (error) {
      yield put({ type: MODULES_ACTIONS.GET_STATE_FROM_API_FAILURE, payload: error });
    }
  });
}

function* deleteItem() {
  yield takeLatest(MODULES_ACTIONS.DELETE_ITEM, function* (action) {
    const { onSuccess, onError } = action.payload;
    try {
      const response = yield apiRequest(`api/v1/modules/${action.payload.id}`, {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      });

      if (!response.data) {
        throw new Error('No data found');
      }

      yield put({ type: MODULES_ACTIONS.DELETE_ITEM_SUCCESS, payload: { id: action.payload.id } });

      onSuccess();
    } catch (error) {
      yield put({ type: MODULES_ACTIONS.DELETE_ITEM_FAILURE, payload: error });

      onError();
    }
  });
}

function* createModule() {
  yield takeLatest(MODULES_ACTIONS.CREATE_MODULE, function* (action) {
    const { module, onSuccess, onError } = action.payload;
    try {
      const response = yield apiRequest('api/v1/modules', {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(module),
      });

      if (!response.ok) {
        throw new Error(response.message || 'Something went wrong!');
      }

      yield put({ type: MODULES_ACTIONS.CREATE_MODULE_SUCCESS, payload: response.data });
      onSuccess();
    } catch (error) {
      yield put({ type: MODULES_ACTIONS.CREATE_MODULE_FAILURE, payload: error });
      onError();
    }
  });
}

function* updateModule() {
  yield takeLatest(MODULES_ACTIONS.UPDATE_MODULE, function* (action) {
    const { module, onSuccess, onError } = action.payload;
    try {
      const response = yield apiRequest(`api/v1/modules/${module.id}`, {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body: JSON.stringify(module),
      });

      if (!response.ok) {
        throw new Error(response.message || 'Something went wrong!');
      }

      yield put({ type: MODULES_ACTIONS.UPDATE_MODULE_SUCCESS, payload: response.data });
      onSuccess();
    } catch (error) {
      yield put({ type: MODULES_ACTIONS.UPDATE_MODULE_FAILURE, payload: error });
      onError();
    }
  });
}

export default function* saga() {
  yield spawn(getStateFromApi);
  yield spawn(deleteItem);
  yield spawn(createModule);
  yield spawn(updateModule);
}
